export function svgToPng(dom: SVGSVGElement) {
  const svgString = new XMLSerializer().serializeToString(dom)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!

  const img = new Image()
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
  const url = URL.createObjectURL(svgBlob)

  img.onload = function () {
    ctx.drawImage(img, 0, 0)
    const imgURL = canvas.toDataURL('image/png')

    // 创建下载链接
    const a = document.createElement('a')
    a.href = imgURL
    a.download = 'image.png' // 设置下载文件名
    document.body.appendChild(a)
    a.click() // 触发下载
    document.body.removeChild(a) // 移除链接

    URL.revokeObjectURL(url) // 释放内存
  }
  img.src = url
  canvas.width = dom.width.baseVal.value
  canvas.height = dom.height.baseVal.value
}
